'use client'
import dynamic from 'next/dynamic'
import NotificationBell from './notification-bell'
const Inbox = dynamic(() => import('./notification-inbox'), {
  ssr: false,
  loading: () => <NotificationBell disabled aria-busy="true" />,
})

export default function NotificationHub({
  userId,
  canManage = false,
  enabled = false,
  layout = 'navbar',
}) {
  return userId && enabled ? (
    <Inbox key={userId} userId={userId} canManage={canManage} layout={layout} />
  ) : null
}
